import React, { useEffect, useMemo, useState } from 'react';

import PageHeader from '../../../components/PageHeader/PageHeader';
import PreparationsTable from '../../../components/PreparationsTable/PreparationsTable';
import CategoriesTable from '../../../components/Category/CategoriesTable';
import { Tabs, Tab, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomTabPanel from '../../../components/Tab/CustomTabPanel';
import { categoryOptions, permissionOptions } from '../../../utils/Enums';
import { useParams } from 'react-router-dom';
import BulkImportButton from '../../../components/BulkImport/BulkImportButton';

export default function Preparation() {
  
  const { t } = useTranslation();
  const { locationId } = useParams();
  const [tabValue, setTabValue] = useState(0);

  const userPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
  const hasPermission = (permissionId) => userPermissions.includes(permissionId);
  const canViewCategories = hasPermission(permissionOptions.find(p => p.label === 'VIEW_CATEGORY').id);

  const tabs = useMemo(() => {
    const items = [];
    items.push({
      key: 'preparations',
      label: t('preparations'),
      content: (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2 }}>
            <PageHeader title={t('preparations')} subtitle={t('manage_preparations')} />
            <BulkImportButton type="preparations" label={t('preparations')} onSuccess={() => window.location.reload()} />
          </Box>
          <PreparationsTable locationId={locationId} isBranch={false}/>
        </>
      )
    });
    if (canViewCategories) {
      items.push({
        key: 'categories',
        label: t('category_preparations'),
        content: (
          <>
            <PageHeader title={t('category')} subtitle={t('category_header')} />
            <CategoriesTable categoryType={ categoryOptions.PREPARATIONS } />
          </>
        )
      });
    }
    return items;
  }, [canViewCategories, locationId, t]);

  useEffect(() => {
    if (tabValue >= tabs.length) {
      setTabValue(Math.max(0, tabs.length - 1));
    }
  }, [tabValue, tabs.length]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleChangeTab} aria-label="basic tabs example">
          {tabs.map((tab) => (
            <Tab key={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      {tabs.map((tab, index) => (
        <CustomTabPanel key={tab.key} value={tabValue} index={index}>
          {tab.content}
        </CustomTabPanel>
      ))}
    </div>
  );
}
